// Virtual thread list: rows are fetched in chunk-aligned (offset, limit) ranges as the user
// scrolls. 50 rows ≈ 3.5 viewports, so a visible window + overscan touches at most two chunks.
export const THREAD_CHUNK_SIZE = 50;
// Server hard ceiling for one range/search/grouped fetch (mirrors backend DefaultThreadMaxPageSize).
export const THREAD_FETCH_MAX_LIMIT = 200;
// Server hard ceiling for `offset` (mirrors backend DefaultThreadMaxOffset) — offsets past it
// would 400, so the window stops fetching there and deeper rows stay skeletons.
export const THREAD_MAX_OFFSET = 100000;
// Search is a single capped fetch — recall is server-capped anyway, paging past it is fake.
export const THREAD_SEARCH_LIMIT = 200;
// Internal Chats stay a single unpaginated fetch (low volume).
export const INTERNAL_THREADS_LIMIT = 200;

export const DEFAULT_THREAD_UNNAMED_LABEL = "unnamed";
export const DEFAULT_THREAD_METADATA_DEFAULT_LABEL = "default";
export const MESSAGES_SELECTED_THREAD_STORAGE_PREFIX = "healo-messages-selected-thread";
export const MESSAGES_RIGHT_PANEL_OPEN_KEY = "healo.messages.rightPanelOpen";
// Which right-hand conversation panel is shown when open: "participants" | "tasks".
export const MESSAGES_RIGHT_PANEL_MODE_KEY = "healo.messages.rightPanelMode";
